module.exports = __webpack_public_path__ + "img/navigation_arrow.8c805d1c.svg";